class CommonHelper {
  Sleep(timeout: number) {
    console.log("延时：" + timeout);
    return new Promise((resolve) => setTimeout(resolve, timeout));
  }
  validatePhone(value) {
    if (!/^1[345789]\d{9}$/.test(value)) {
      return "手机号格式不正确";
    } else {
    }
  }
  validateIP(value) {
    if (value === "" || typeof value === "undefined" || value == null) {
      return false;
    } else {
      const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      if (!reg.test(value) && value !== "") {
        return false;
      } else {
        return true;
      }
    }
  }
}

const commonHelper = new CommonHelper();
export default commonHelper;
